import { BAND_DOT, band, bandCounts, bandSummary } from "@/lib/setup/grades";
import { cn } from "@/lib/utils";

/** ③: a 0–100 track with one dot per graded paper, ticks at the 50/80 band
 *  edges, and the band summary (the accessible text). Dots are mouse-only
 *  (aria-hidden, not focusable); keyboard focus on a row's marks highlights its dot. */
export function GradeStrip({ items, active, onActive }: {
  items: { key: string; title: string; score: number }[];
  active: string | null;
  onActive: (key: string | null) => void;
}) {
  return (
    <div className="flex flex-col gap-1">
      <div className="relative h-7">
        <div aria-hidden className="absolute inset-x-0 top-[13px] h-0.5 rounded-full bg-muted" />
        {[50, 80].map((t) => (
          <div key={t} data-tick aria-hidden className="absolute top-1 h-5 w-px bg-border" style={{ left: `${t}%` }} />
        ))}
        {items.map((it) => (
          <span
            key={it.key}
            data-dot
            aria-hidden
            title={`${it.score} — ${it.title}`}
            onMouseEnter={() => onActive(it.key)}
            onMouseLeave={() => onActive(null)}
            className={cn(
              "absolute top-2 size-3 -translate-x-1/2 rounded-full",
              BAND_DOT[band(it.score)],
              active === it.key && "z-10 scale-150 ring-2 ring-primary ring-offset-1 ring-offset-background",
            )}
            style={{ left: `${it.score}%` }}
          />
        ))}
      </div>
      <div className="flex justify-between text-xs tabular-nums text-muted-foreground">
        <span>0</span>
        <span>{bandSummary(bandCounts(items.map((i) => i.score)))}</span>
        <span>100</span>
      </div>
    </div>
  );
}
